"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mkVfxSequenceBuilder = exports.isVfxSequenceBuilder = void 0;
const core_1 = require("./core");
function isVfxSequenceBuilder(maybe) {
    return (maybe === null || maybe === void 0 ? void 0 : maybe.__is_vfx_sequence__) === true;
}
exports.isVfxSequenceBuilder = isVfxSequenceBuilder;
function mkVfxSequenceBuilder(type) {
    const children = Array.of();
    return {
        __is_vfx_sequence__: true,
        __type: type,
        mk() {
            // TODO: optimize for deeply nested children.
            const steps = children.flatMap(child => {
                if (!isVfxSequenceBuilder(child)) {
                    return child;
                }
                const seq = child.mk();
                if (seq.__typeName !== "Parallel" && seq.__typeName !== "Sequential") {
                    return seq;
                }
                else if (seq.children.length === 1) {
                    // replace self with child
                    return seq.children.at(0);
                }
                else if (seq.__typeName === "Parallel" && type === "parallel") {
                    // replace self with children
                    return seq.children;
                }
                else if (seq.__typeName === "Sequential" && type === "sequential") {
                    // replace self with children
                    return seq.children;
                }
                return seq;
            }).filter(step => step.__typeName !== "None");
            if (steps.length === 0) {
                // remove self
                return new core_1.NoneVfxStepArgs();
            }
            else if (steps.length === 1) {
                // replace self with child
                return steps.at(0);
            }
            const seq = type === "sequential" ? new core_1.SequentialVfxStepArgs(steps)
                : type === "parallel" ? new core_1.ParallelVfxStepArgs(steps)
                    : new core_1.NoneVfxStepArgs();
            return seq;
        },
        pushArgs(args) {
            children.push(args);
            return args.id;
        },
        push(...args) {
            children.push(...args);
            return this;
        },
        pushSequence(nextType) {
            if (type === nextType) {
                return this;
            }
            const sequence = mkVfxSequenceBuilder(nextType);
            children.push(sequence);
            return sequence;
        }
    };
}
exports.mkVfxSequenceBuilder = mkVfxSequenceBuilder;
